import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneereligiontourpackagecab() {



  const cardData = {
"keyword": "Pune Religious Tour Package Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Religious Tour Package Cab for devotees and spiritual travelers who want to explore Maharashtra’s most sacred temples and pilgrimage destinations in a safe, convenient, and well-organized manner. Whether you are planning temple darshan, multi-day pilgrimage, family religious tour, senior citizen-friendly journey, Ashtavinayak yatra, Jyotirlinga visit, or customized spiritual travel, our cab service ensures a smooth and stress-free experience. With experienced drivers who are familiar with temple routes, highways, and rural pilgrimage circuits, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for individuals, families, and large groups. With flexible custom packages, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a peaceful and spiritually fulfilling religious tour experience.",

"topPlaces": [
  {
    "title": "Ashtavinayak Ganpati Temples",
    "description":
      "The Ashtavinayak pilgrimage includes eight sacred Ganesha temples across Maharashtra such as Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. It is one of the most important religious circuits starting from Pune, offering a complete spiritual experience of devotion, history, and tradition."
  },
  {
    "title": "Bhimashankar Jyotirlinga",
    "description":
      "Bhimashankar Jyotirlinga is one of the twelve holy Jyotirlingas of Lord Shiva located in the Sahyadri hills. Surrounded by dense forests and scenic landscapes, it is a highly revered pilgrimage site for Shiva devotees."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description":
      "Shirdi Sai Baba Temple is one of India’s most visited pilgrimage destinations dedicated to Sai Baba. Devotees from Pune travel here for darshan, aarti, and spiritual blessings in a peaceful and devotional atmosphere."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description":
      "Shani Shingnapur Temple is famous for its unique open-air shrine of Lord Shani and strong spiritual beliefs. It is a major stop in religious tour packages from Pune."
  },
  {
    "title": "Tuljapur Bhavani Temple",
    "description":
      "Tuljapur Bhavani Temple is one of the most powerful Shakti Peethas in Maharashtra dedicated to Goddess Bhavani. It holds deep historical and spiritual importance in Maharashtra’s devotional culture."
  },
  {
    "title": "Pandharpur Vitthal Rukmini Temple",
    "description":
      "Pandharpur is a sacred pilgrimage town dedicated to Lord Vitthal and Rukmini located on the banks of the Chandrabhaga River. It attracts lakhs of devotees during Wari and throughout the year."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description":
      "Akkalkot Swami Samarth Temple is a revered spiritual center dedicated to Swami Samarth Maharaj, known for peace, devotion, and blessings sought by thousands of devotees."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description":
      "Jejuri Khandoba Temple is a famous hilltop temple dedicated to Lord Khandoba, known for its turmeric rituals and vibrant spiritual celebrations attracting devotees from across Maharashtra."
  },
  {
    "title": "Ganpatipule Temple",
    "description":
      "Ganpatipule is a unique coastal pilgrimage destination featuring a self-manifested Ganpati temple located beside the Arabian Sea, combining spirituality with scenic beach beauty."
  },
  {
    "title": "Maharashtra Spiritual Circuit Route",
    "description":
      "The Pune religious tour package covers a wide network of temples, Jyotirlingas, Shakti Peethas, and coastal shrines across Maharashtra, offering a complete and comfortable spiritual journey experience."
  }
],



services: [
  {
    name: "Pune Religious Tour Cab",
    description: "Pune religious tour cab service provides reliable transportation for devotees and travelers visiting famous temples and spiritual destinations around Pune and Maharashtra. Comfortable vehicles with experienced drivers ensure smooth travel for families, pilgrims, tourists, and senior citizens. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different pilgrimage travel requirements. Flexible booking options allow convenient religious tour cab reservations."
  },
  {
    name: "Pune Pilgrimage Tour Package Cab",
    description: "Pune pilgrimage tour package cab service offers dependable transportation for complete pilgrimage tours and temple visits with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for religious tourism, family darshan trips, and group pilgrimage tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient pilgrimage package cab reservations."
  },
  {
    name: "Pune Spiritual Tour Package Taxi",
    description: "Pune spiritual tour package taxi service provides comfortable transportation for devotees visiting temples, pilgrimage centers, and sacred attractions around Pune. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys across spiritual destinations. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day and multi-day spiritual travel requirements. Flexible booking options allow convenient spiritual package taxi reservations."
  },
  {
    name: "Pune Temple Tour Package Cab",
    description: "Pune temple tour package cab service offers reliable transportation with comfortable vehicles and professional drivers for temple tours and spiritual journeys from Pune. Vehicles provide smooth city and highway travel suitable for temple tourism, family darshan trips, and cultural visits. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy temple tour package cab reservations."
  },
  {
    name: "Pune Religious Travel Package Cab",
    description: "Pune religious travel package cab service provides dependable transportation solutions for passengers traveling to temples and sacred destinations from Pune. Vehicles are suitable for city and long-distance temple travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for spiritual travel, darshan tours, and pilgrimage visits. Flexible booking options allow convenient religious travel package cab reservations."
  },
  {
    name: "Best Pune Religious Cab Package",
    description: "Best Pune religious cab package service provides transparent and reliable transportation for devotees planning comfortable temple tours and spiritual journeys from Pune. Travelers can enjoy peaceful journeys with experienced drivers familiar with temple routes and pilgrimage destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient religious cab package reservations."
  },
  {
    name: "Cheap Pune Religious Tour Cab",
    description: "Cheap Pune religious tour cab service provides economical and comfortable transportation for families and devotees planning temple tours from Pune. Vehicles ensure smooth city and highway travel suitable for pilgrimage tourism, family darshan trips, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow affordable religious tour cab reservations."
  },
  {
    name: "SUV Pune Religious Package Cab",
    description: "SUV Pune religious package cab service offers spacious transportation for families and groups planning temple visits and spiritual tours from Pune. SUV vehicles provide comfortable seating, smooth ride quality, and luggage space suitable for long-distance religious travel. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV religious package cab reservations."
  },
  {
    name: "Innova Pune Religious Tour Cab",
    description: "Innova Pune religious tour cab service allows passengers to reserve premium SUV transportation for comfortable temple tours and pilgrimage journeys from Pune. Innova vehicles provide spacious seating and smooth highway travel suitable for families, senior citizens, and group darshan travel. Professional drivers ensure safe driving and punctual pickup services throughout the temple tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova religious tour cab reservations."
  },
  {
    name: "Sedan Pune Religious Taxi",
    description: "Sedan Pune religious taxi service provides affordable transportation for devotees planning spiritual journeys and temple visits from Pune. Sedan vehicles ensure reliable city and highway travel suitable for spiritual tourism, pilgrimage tours, and family darshan trips. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient sedan religious taxi reservations."
  },
  {
    name: "Pune Temple Package Tour Cab",
    description: "Pune temple package tour cab service offers premium transportation with comfortable vehicles and professional chauffeurs for religious tours and temple travel from Pune. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for spiritual tourism and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient temple package tour cab reservations."
  },
  {
    name: "Pune Spiritual Package Travel Cab",
    description: "Pune spiritual package travel cab service provides comfortable transportation for devotees planning same-day and multi-day temple darshan tours from Pune. Vehicles ensure smooth and safe city and highway travel suitable for spiritual tourism, family travel, and temple visits. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient spiritual package travel cab reservations."
  },
  {
    name: "Pune Holy Tour Cab",
    description: "Pune holy tour cab service provides dependable transportation for passengers planning spiritual and temple tours from Pune. Comfortable vehicles ensure smooth travel suitable for pilgrimage tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient holy tour cab reservations."
  },
  {
    name: "Pune Pilgrimage Travel Package",
    description: "Pune pilgrimage travel package service provides reliable transportation for travelers and devotees planning temple tours and spiritual journeys around Pune and nearby pilgrimage destinations. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, senior citizens, and pilgrimage groups. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient pilgrimage travel package reservations."
  },
  {
    name: "Pune Religious Sightseeing Package Cab",
    description: "Pune religious sightseeing package cab service offers comfortable transportation for passengers planning religious tours and spiritual journeys from Pune to major pilgrimage destinations. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for spiritual tourism, temple darshan, and family pilgrimage travel. Flexible booking options allow convenient religious sightseeing package cab reservations."
  }
],

tableData: [
  ["Pune Religious Tour Cab", "Pune Pilgrimage Tour Package Cab"],
  ["Pune Spiritual Tour Package Taxi", "Pune Temple Tour Package Cab"],
  ["Pune Religious Travel Package Cab", "Best Pune Religious Cab Package"],
  ["Cheap Pune Religious Tour Cab", "SUV Pune Religious Package Cab"],
  ["Innova Pune Religious Tour Cab", "Sedan Pune Religious Taxi"],
  ["Pune Temple Package Tour Cab", "Pune Spiritual Package Travel Cab"],
  ["Pune Holy Tour Cab", "Pune Pilgrimage Travel Package"],
  ["Pune Religious Sightseeing Package Cab", "Pune Religious Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Religious Tour Package Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Religious Tour Package cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and peaceful spiritual travel."
      },
      {
        WhyChooseheading: "Affordable Religious Tour Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Religious Tour Package cab pricing with transparent fare details and no hidden charges. Customers receive complete religious tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Religious Tour Cab Availability",
        WhyChoosedescription: "Our Pune Religious Tour Package cab service operates 24 hours a day for temple visits, family pilgrimages, spiritual tours, darshan trips, and customized religious travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during religious tour journeys."
      },
      {
        WhyChooseheading: "Customized Religious Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Shirdi tours, Ashtavinayak Darshan, Jyotirlinga tours, Pandharpur trips, Tuljapur tours, and customized spiritual travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for pilgrims, families, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Religious Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with major temple and pilgrimage routes across Maharashtra and nearby states, ensuring safe driving, smooth travel, and timely darshan for every spiritual journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Religious Tour Package cab service?", answer: "Pune Religious Tour Package cab service provides comfortable taxi transportation for visiting famous temples, pilgrimage destinations, and spiritual places from Pune." },
    { question: "Is Pune Religious Tour Package cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Religious Tour Package cab service." },
    { question: "Which vehicles are available for religious tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized religious tour packages?", answer: "Yes, customers can book customized temple and pilgrimage travel packages according to their requirements." },
    { question: "Which religious destinations are covered in Pune Religious Tour Packages?", answer: "Shivai Travels covers destinations like Shirdi, Ashtavinayak temples, Tuljapur, Pandharpur, Bhimashankar, Trimbakeshwar, and Jyotirlinga tours." },
    { question: "Are all religious tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Pune Religious Tour Package cab service online?", answer: "Yes, customers can easily book Pune Religious Tour Package cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Pune Religious Tour Package cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Religious Tour Package cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Prakash Deshmukh",
      feedback:
        "Booked Pune Religious Tour Package cab service with Shivai Travels. Comfortable vehicle, smooth pilgrimage journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Pune Religious Tour taxi service. Affordable pricing, clean cab, and wonderful spiritual travel experience.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Religious Tour Package Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-religious-tour-cab.jpg",
  "description": "Book Pune Religious Tour Package cab service for comfortable and organized temple and pilgrimage travel. Shivai Travels offers customized spiritual tour packages with sedan, SUV, Innova, and luxury cab options available 24x7 for temple darshan, holy places, and religious circuits around Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-religious-tour-package-cab"
  }
};






  return (
    <div>


<Helmet>
  <title>Pune Religious Tour Package Cab | Pilgrimage Travel Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Religious Tour Package cab service for temple and pilgrimage travel. Affordable spiritual tour packages with sedan, SUV, Innova, and luxury cabs available 24x7 for holy places, temple darshan, and religious sightseeing."
  />

  <meta
    name="keywords"
    content="pune religious tour cab, pune pilgrimage tour package cab, pune spiritual tour package taxi, pune temple tour package cab, pune religious travel package cab, best pune religious cab package, cheap pune religious tour cab, suv pune religious package cab, innova pune religious tour cab, sedan pune religious taxi, pune temple package tour cab, pune spiritual package travel cab, pune holy tour cab, pune pilgrimage travel package, pune religious sightseeing package cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneereligiontourpackagecab;